const SESSION_TOKEN_KEY = "wendo.session.token.v1";

export interface SessionStore {
  readonly key: string;
  get(): string | null;
  set(token: string): void;
  clear(): void;
}

export function createSessionStore(storage: Storage): SessionStore {
  return {
    key: SESSION_TOKEN_KEY,
    get(): string | null {
      const value = storage.getItem(SESSION_TOKEN_KEY)?.trim();
      return value === undefined || value.length === 0 ? null : value;
    },
    set(token: string): void {
      storage.setItem(SESSION_TOKEN_KEY, token);
    },
    clear(): void {
      storage.removeItem(SESSION_TOKEN_KEY);
    },
  };
}

export const sessionStore = createSessionStore(window.sessionStorage);
